import React from 'react';
import PropTypes from 'prop-types';
import { Card, Checkbox, Form } from 'antd';
import icon1 from '../../../../../../assets/images/investor-profiles/1.svg';
import icon2 from '../../../../../../assets/images/investor-profiles/2.svg';
import icon3 from '../../../../../../assets/images/investor-profiles/3.svg';
import './styles.less';

const InvestorProfileLegal = ({ profile, isConfirmed, onConfirmToggle }) => {
  const images = [icon1, icon2, icon3];

  const image = images[profile.id - 1];

  return (
    <Card className="investor-profile-legal">
      <div className="investor-profile-legal-header">
        <img
          className="investor-profile-legal-header__icon"
          alt="Icono del perfil de inversionista"
          src={image}
        />
        <h2 className="investor-profile-legal-header__title">{profile.name}</h2>
      </div>
      <p>{profile.description}</p>
      <Form.Item
        name="confirmedProfile"
        rules={[
          {
            validator: () =>
              isConfirmed
                ? Promise.resolve()
                : Promise.reject(new Error('Debe estar de acuerdo con su perfil')),
            message: 'Debe estar de acuerdo con su perfil',
          },
        ]}
        valuePropName="checked"
      >
        <Checkbox checked={isConfirmed} onChange={onConfirmToggle}>
          Entiendo la selección de mi tipo de perfil.
        </Checkbox>
      </Form.Item>
    </Card>
  );
};

InvestorProfileLegal.propTypes = {
  profile: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
  isConfirmed: PropTypes.bool.isRequired,
  onConfirmToggle: PropTypes.func.isRequired,
};

export default InvestorProfileLegal;
